import { ReactElement } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import { EStatus } from 'src/app/project/shared/enums/status.enum';
import BulkOptionDialog, { TBulkOption } from './BulkOptionDialog';
import StatusLabel, { STATUS_OPTIONS } from './StatusLabel';

type TBulkStatusDialogProps = {
  onClose: () => void;
  onSave: (status: EStatus) => Promise<void>;
};

const OPTIONS: TBulkOption<EStatus>[] = STATUS_OPTIONS.map((option) => ({
  value: option.value,
  label: <StatusLabel option={option} />,
}));

const BulkStatusDialog = ({ onClose, onSave }: TBulkStatusDialogProps): ReactElement => (
  <BulkOptionDialog
    title={translate('change_status')}
    sectionLabel={translate('status')}
    options={OPTIONS}
    onClose={onClose}
    onSave={onSave}
  />
);

export default BulkStatusDialog;
